import { render } from "./v-chip.vue?vue&type=template&id=927215de&scoped=true"
import script from "./v-chip.vue?vue&type=script&lang=js"
export * from "./v-chip.vue?vue&type=script&lang=js"

import "./v-chip.vue?vue&type=style&index=0&id=927215de&scoped=true&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927215de"]])

export default __exports__